(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-only-featured-block-with-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-block')) {
    class SlideshowBlock extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        document.addEventListener('DOMContentLoaded', () => {
          const carouselImages = this.querySelector('[data-carousel-images]');
          const carousel = this.querySelector('[data-carousel]');
                    
          const flktyOptions_featCarousel = {
            "cellAlign": "left",
            "contain": true,
            "wrapAround": true,
            "prevNextButtons": false,
            "pageDots": true,
            "selectedAttraction": 0.04,
            "friction": 0.4,
            "sync": carouselImages
          };

          if (window.matchMedia('screen and (min-width: 900px)').matches ) {
            flktyOptions_featCarousel.prevNextButtons = true;
            flktyOptions_featCarousel.pageDots = false;
          }

          const flktyOptions_featCarouselImages = {
            "cellAlign": "left",
            "contain": true,
            "wrapAround": true,
            "pageDots": false,
            "prevNextButtons": false,
            "imagesLoaded": true,
            "draggable": true,
            "selectedAttraction": 0.04,
            "friction": 0.4,
          };
          
          this.carouselInit = new Flickity(carousel, flktyOptions_featCarousel);
          this.carouselImagesInit = new Flickity(carouselImages, flktyOptions_featCarouselImages);
          
          window.addEventListener('load', () => {
            setTimeout(() => {
              this.carouselInit.resize();
              this.carouselImagesInit.resize();
            }, 300);
          });
          
          window.addEventListener('coco-shuffle:variant-updated', () => {
            setTimeout(() => {
              this.carouselInit.resize();
              this.carouselImagesInit.resize();
            }, 300);
          });
        });
      }
    }
    customElements.define('slideshow-block', SlideshowBlock);
  }

  } catch(e) { console.error(e); }
})();
})();
